import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { helpCenterLink, programDetailsLink, menuFaqRewardsLink } from '../../../common/Constants';

const LINKS = [
    { label: 'Visit Our Help Center', href: helpCenterLink },
    { label: 'View Program Details', href: programDetailsLink },
    { label: 'View Rewards FAQs', href: menuFaqRewardsLink },
];

const SupportLinks = () => (
    <>
        <div className={dt(['w-full', 'h-px', 'bg-gray-25', 'clear-left'])} />
        <div
            className={dt([
                'w-full',
                'bg-white',
                'flex',
                'flex-col',
                'items-center',
                'px-6',
                'pt-10',
                'gap-6',
                'md:flex-row',
                'md:justify-between',
                'md:items-baseline',
                'md:gap-4',
                'lg:gap-0',
                'lg:px-0',
                'lg:pt-6',
                'xl:pt-10',
            ])}
        >
            <span
                className={dt([
                    'font-open-sans-semibold',
                    'text-black',
                    'text-[20px]',
                    'leading-[1.4]',
                ])}
            >
                Have Questions?
            </span>
            {LINKS.map(({ label, href }) => (
                <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={dt(['no-underline', 'inline-block'])}
                >
                    <span
                        className={dt(['font-open-sans-regular', 'text-normal', 'text-black'])}
                        style={{ borderBottom: '1px solid black' }}
                    >
                        {label}
                    </span>
                </a>
            ))}
        </div>
    </>
);

export default SupportLinks;
